import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(({ breakpoints, zIndex }) => ({
  root: {
    display: 'none',
    position: 'relative',
    zIndex: zIndex.drawer + 1,
    [breakpoints.up('md')]: {
      display: 'block',
    },
  },
}));
